import {
    ApplicationConfig,
    inject,
    Injector,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { PUBLIC_CONFIG_LOADER } from './public-config-loader';
import { PublicConfigStore } from './public-config.store';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { AUTH_STARTUP } from './auth/auth.startup';
import { AuthTokenInterceptor } from './auth/auth-token.interceptor';
import { provideMarkdown } from 'ngx-markdown';
import { provideToastr } from 'ngx-toastr';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideAppInitializer(() => {
            const publicConfigStore = inject(PublicConfigStore);
            const httpClient = inject(HttpClient);
            const injector = inject(Injector);

            return Promise.resolve()
                .then(() =>
                    PUBLIC_CONFIG_LOADER(publicConfigStore, httpClient)(),
                )
                .then(() =>
                    AUTH_STARTUP(publicConfigStore, injector)()
                )
                .then(() => {
                    const globalLoader = window.document.getElementById('globalLoader');
                    if (globalLoader !== null) {
                        globalLoader.classList.add('closing');
                        setTimeout(() => {
                            globalLoader.remove();
                        }, 1000);
                    }

                    return Promise.resolve(true);
                });
        }),
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        provideMarkdown(),
        provideToastr(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
};
